import { throttle } from 'es-toolkit/compat';
export default throttle;
